<template>
  <div>
    <textarea
      class="form-control form-control-lg"
      :value="value"
      @input="input">
      </textarea>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    input (el) {
      this.$emit('input', el.target.value)
    }
  }
}
</script>

<style scoped>
</style>
